import * as React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const Chat = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-chat', 'flex min-h-[200px] flex-grow flex-col gap-3 rounded-xl border border-neutral-lightest bg-white p-5 shadow-dropshadow-sm', className)}
    {...props}
  />
));
Chat.displayName = 'Chat';

const ChatBody = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-chat-body', 'flex h-[200px] flex-grow flex-col-reverse overflow-y-auto pr-3 [&>.c-empty-state]:m-auto', className)}
    {...props}
  />
));
ChatBody.displayName = 'ChatBody';

const chatFooterVariants = cva('flex flex-col gap-2 rounded', {
  variants: {
    variant: {
      default: '',
      reply: 'p-3 bg-neutral-bright'
    }
  },
  defaultVariants: {
    variant: 'default'
  }
});

const ChatFooter = React.forwardRef(({ className, variant, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-chat-footer', chatFooterVariants({ variant }), className)}
    {...props}
  />
));
ChatFooter.displayName = 'ChatFooter';

const ChatForm = React.forwardRef(({ className, ...props }, ref) => (
  <form
    ref={ref}
    className={cn('c-chat-form', 'flex items-center gap-2 [&_input::placeholder]:text-neutral', className)}
    {...props}
  />
));
ChatForm.displayName = 'ChatForm';

const ChatOriginalText = React.forwardRef(({ className, variant, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('c-chat-original-text', 'mb-0 max-w-full truncate text-xs font-bold text-neutral', className)}
    {...props}
  />
));
ChatOriginalText.displayName = 'ChatOriginalText';

export { Chat, ChatBody, ChatFooter, ChatForm, ChatOriginalText };
